import React from "react";
import "./AboutUs.css";

const AboutUs = () => {
  return (
    <div className="about-us-container">
      <h6>About Us</h6>
      <h2>Our Story</h2>
      <div className="our-story-section">
        <div className="the-story">
          <p>
            We then realised we all eat what is <strong>most convenient</strong>{" "}
            and this was not always the healthiest choice, so we decided to take
            a different road in June 2021. We then decided to help people become
            more food conscious of what they were eating, for a more healthier
            and more prosperous future.{" "}
            <strong>Knowing our health is our wealth. </strong>
          </p>

          <p>
            This change did not come without its own costs losing almost all of
            our current clientele at the time when making the shift, but we knew
            it had to be done. You do ask yourself the question after losing 90%
            of your revenue for two months if you have made the right move.
          </p>
          <p>
            As a <strong>healthy food provider</strong>, we are happy to have
            helped <strong> thousands of people</strong> get their weight and
            health back on track by eating well portioned and healthy meals. It
            is a lifestyle we now live and preach to our clients, family, and
            friends every day.
          </p>
          <p>
            At the end of the day it is all about your{" "}
            <strong>lifestyle choices. </strong>
          </p>
          <p>
            The SMOOTHIE brand strives for quality and consistency. We have a
            loving and passionate team ensuring we give you the best quality
            possible.
          </p>
          <p>
            We ensure you live a happy and<strong> healthy lifestyle</strong>{" "}
            all with the convenience of us delivering to your doorstep, offering
            you a great experience every time you order from start to finish.
            Part of our vision is a <strong>better U.</strong>
          </p>
        </div>
        <div className="aesthetic-img">
          <img
            src="https://cdn.lifehack.org/wp-content/uploads/2016/08/benefits-of-green-smoothies-1024x768.jpeg"
            alt=""
          />
          <img
            src="https://post.healthline.com/wp-content/uploads/2016/03/Daughter_Mother_Smoothie_732x549-thumbnail-732x549.jpg"
            alt=""
          />
        </div>
      </div>
      <h1>Ours Values</h1>
      <div className="our-values-section">
        <ul>
          <li>
            {" "}
            <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24">
              <path d="m9.55 18-5.7-5.7 1.425-1.425L9.55 15.15l9.175-9.175L20.15 7.4Z" />
            </svg>
            <strong>Quality:</strong> Adhere to produce a product selection
            criterion that proudly provides a wide variety of products
          </li>
          <li>
            <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24">
              <path d="m9.55 18-5.7-5.7 1.425-1.425L9.55 15.15l9.175-9.175L20.15 7.4Z" />
            </svg>
            <strong>Integrity:</strong> We demonstrate the highest ethical
            standards in all interactions.
          </li>
          <li>
            <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24">
              <path d="m9.55 18-5.7-5.7 1.425-1.425L9.55 15.15l9.175-9.175L20.15 7.4Z" />
            </svg>
            <strong>Respect:</strong> We will treat all of our relationships
            with respect.
          </li>
          <li>
            <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24">
              <path d="m9.55 18-5.7-5.7 1.425-1.425L9.55 15.15l9.175-9.175L20.15 7.4Z" />
            </svg>
            <strong>Pride: </strong> Add value to our clients lives by helping
            achieve healthier lifestyle goals.
          </li>
          <li>
            <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24">
              <path d="m9.55 18-5.7-5.7 1.425-1.425L9.55 15.15l9.175-9.175L20.15 7.4Z" />
            </svg>
            <strong>Resilience: </strong> Rapidly adapt and respond to our
            clients and their orders.
          </li>
          <li>
            <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24">
              <path d="m9.55 18-5.7-5.7 1.425-1.425L9.55 15.15l9.175-9.175L20.15 7.4Z" />
            </svg>
            <strong>Loyalty:</strong> Our team has your best interest at heart,
            ensuring we build a strong relationship with all our clients.
          </li>
        </ul>
      </div>
      <div className="mission-vision">
        <div className="mission">
          <h2>Our Mission</h2>
          <ul>
            <li>
              As one of South Africa’s leading health and wellness online
              companies, we constantly strive to supply all our clients with the
              highest quality, best tasting, and most nutritious meals.
            </li>
            <li>
              We know how difficult it is to maintain and sustain a healthy
              lifestyle in this current rat race we live in! There are so many
              easy way outs and not enough healthy and affordable options.
            </li>
            <li>
              Our main focus is to transform your lifestyle and improving your
              overall health and well-being with easy access to healthy,
              well-portioned, nutritious, and convenient meals giving you the
              BEST results. We ensure that every mouthful not only tastes great
              but shows you healthy eating does not have to be bland.
            </li>
          </ul>
        </div>
        <div className="vision">
          <h2>Our Vision</h2>
          <ul>
            <li>
              As one of South Africa’s leading health and wellness online
              companies, we constantly strive to supply all our clients with the
              highest quality, best tasting, and most nutritious meals.
            </li>
            <li>
              We know how difficult it is to maintain and sustain a healthy
              lifestyle in this current rat race we live in! There are so many
              easy way outs and not enough healthy and affordable options.
            </li>
            <li>
              Our main focus is to transform your lifestyle and improving your
              overall health and well-being with easy access to healthy,
              well-portioned, nutritious, and convenient meals giving you the
              BEST results. We ensure that every mouthful not only tastes great
              but shows you healthy eating does not have to be bland.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
